import React from 'react';
import CapsuleNew from 'components_v2/common/CapsuleNew';

const SeoWidget = ({ item, prefixRequired }) => (
  <>
    {item &&
      item.items.map(it => (
        <CapsuleNew
          item={it}
          link={it.overridelink}
          ga4Type={item.ga4Type}
          ga4Category={item.ga4Category}
          prefixRequired={prefixRequired}
        />
      ))}
  </>
);

export default SeoWidget;
